import { render } from "./MorningPlan.vue?vue&type=template&id=89b2b714&scoped=true"
import script from "./MorningPlan.vue?vue&type=script&lang=js"
export * from "./MorningPlan.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b2b714"]])

export default __exports__